var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.timer > 0)?_c('div',{staticClass:"message",class:'message--' + _vm.message.level},[_c('div',{staticClass:"message__content"},[(_vm.translationPrefix)?_c('span',[_vm._v(_vm._s(_vm.$t(_vm.translationPrefix + '.' + _vm.message.message)))]):_vm._e(),_vm._v(" "),(!_vm.translationPrefix)?_c('span',[_vm._v(_vm._s(_vm.message.message))]):_vm._e()])]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-177767cb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert/Alert.vue
// module id = null
// module chunks = 